import { createLazyFileRoute } from "@tanstack/react-router"

import LandingPage from "#/pages/LandingPage"
import OverviewPage from "#/pages/OverviewPage"
import { ENABLE_LANDING_PAGES, routes } from "#/shared/constants"

export const Route = createLazyFileRoute(routes.LANDING)({
  component: () => (!ENABLE_LANDING_PAGES ? <OverviewPage /> : <LandingPage />),
})
